export const clamp = (number, min = 0, max = 1) =>
  Math.max(min, Math.min(number, max));
